import { render, staticRenderFns } from "./clientPhoneInput.vue?vue&type=template&id=1d3e85d7&"
import script from "./clientPhoneInput.vue?vue&type=script&lang=js&"
export * from "./clientPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports